var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlashDeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.49 7v1.755h1.782v.878a6.057 6.057 0 0 1 1.78 0v-.878h1.782V7H14.49Z",
    fill: "#ED0C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 27.014c4.418 0 8-3.53 8-7.885s-3.582-7.886-8-7.886-8 3.53-8 7.886c0 4.355 3.582 7.885 8 7.885ZM17 28c4.97 0 9-3.972 9-8.871 0-4.9-4.03-8.871-9-8.871s-9 3.972-9 8.87C8 24.029 12.03 28 17 28Z",
    fill: "#ED0C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.217 12.794.624-.615.712.703 1.247-1.23-2.672-2.632-1.246 1.228.712.703-.801.79c-4.274-2.546 4.541 3.861 1.424 1.053Z",
    fill: "#ED0C2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M16.988 12.338c3.59 0 6.5 2.868 6.5 6.407h-6.5v-6.407Z",
    fill: "#ED0C2F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashDeal);
export default __webpack_public_path__ + "static/media/flash-deal.0aa55a945fc90a9bbacf51aabac664a4.svg";
export { ForwardRef as ReactComponent };